import React, { useEffect, useMemo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Header from './../../compoments/Header';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import api from './../../services/axios'
import AlertDialog from './../../compoments/AlertDialog'
import ImageUpload from './../../compoments/ImageUpload'
import Typography from '@material-ui/core/Typography';
import { Breadcrumbs } from '@material-ui/core';
import { Link } from 'react-router-dom'
import { Redirect } from 'react-router'
import DatePicker from './../../compoments/DatePicker';
import TimePickerCustom from './../../compoments/TimePickerCustom';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  appBarSpacer: theme.mixins.toolbar,
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  disabled: {
    padding: 30,
    backgroundColor: 'red'
  }
}));

export default function LoginUpdate({ match }) {

  const role = 'clientes';
  const roleName = 'Gerenciamento';

  const [redirect, setRedirect] = React.useState(false);
  const [id, setId] = React.useState('');
  const [name, setName] = React.useState('');
  const [login, setLogin] = React.useState(null);
  const [logout, setLogout] = React.useState(null);
  // const [email, setEmail] = React.useState('');
  // const [email, setEmail] = React.useState('');
  // const [birthday, setBirthday] = React.useState('');
  // const [stateAddress, setStateAddress] = React.useState('');
  // const [city, setCity] = React.useState('');
  const [message, setMessage] = React.useState(false);
  const [alertTitle, setAlertTitle] = React.useState('');  
  // const [previewImage, setPreviewImage] = React.useState('');
  // const [thumbnail, setThumbnail] = React.useState(null);
  // const [croppedAreaPixels, setCroppedAreaPixels] = React.useState(null);

  // const preview = useMemo(() => {
  //   return thumbnail ? URL.createObjectURL(thumbnail) : null
  // }, [thumbnail])


  const loadData = async () => {
    setId(match.params.id)
    const data = await api.get('/v1/gerencia/logins/' + match.params.id)
    console.log('data', data.data); 
    setName(data.data.operador)
    setLogin(data.data.login || null)
    setLogout(data.data.logout || null)
  }

  useEffect(() => {
    loadData()
  }, [])

  const dateToString = (date, time) => {
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
    const yyyy = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();

    let timeString = '';
    if (time) {
      timeString = ' ' + hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0');
    }
    return yyyy + '-' + mm + '-' + dd + '' + timeString;
  }

  const save = async () => {

    const user = new FormData();
    if(login){
      user.append('login', dateToString(new Date(login), true))
    }
    if(logout){
      user.append('logout', dateToString(new Date(logout), true))
    }
    user.append('_method', 'PUT')
    try { 
      const data = await api.post('/v1/gerencia/logins/' +id+'/update', user, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        }
      });
      console.log('data', data)
      if(data.status){
        setAlertTitle('')
        setRedirect(`/gerencia/logins`)
      }
    } catch(error) {
      setAlertTitle('Erro')
      setMessage(error.response.data.errors[0].message || 'Erro')
    }

  }

  const classes = useStyles();

  return (
    <div className={classes.root}>
      {redirect && <Redirect to={redirect} />}
      <CssBaseline />
      <Header titleHeader={'Editar Clientes'} />
      {/* CONTEUDO */}
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          <Grid container spacing={3}>
            {/* Recent Orders */}
            <Grid item xs={12}>
              <Breadcrumbs aria-label="breadcrumb">
                <Link color="inherit" to={`/gerencia/logins`} >
                  {roleName}
                </Link>
                <Typography color="textPrimary">Login</Typography>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12}>
              <Paper className={classes.paper}>
                <form className={classes.form} noValidate>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TextField
                        variant="outlined"
                        required
                        fullWidth
                        id="name"
                        label="Nome"
                        name="name"
                        autoComplete="name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={3} style={{ alignSelf: 'left' }}>
                      <DatePicker
                        value={login}
                        onChange={setLogin}
                        label={'Login'}
                      />
                    </Grid>
                    <Grid item xs={3} style={{ alignSelf: 'center' }}>
                      <TimePickerCustom
                        value={login}
                        onChange={setLogin}
                        label={'Hora'}
                      />
                    </Grid>
                    {/* <Grid item xs={3} style={{ alignSelf: 'left' }}>
                      <DatePicker
                        value={logout}
                        onChange={setLogout}
                        label={'Logout'}
                      />
                    </Grid>
                    <Grid item xs={3} style={{ alignSelf: 'center' }}>
                      <TimePickerCustom
                        value={logout}
                        onChange={setLogout}
                        label={'Hora'}
                      />
                    </Grid> */}
                    <Grid item xs={12}>
                      <Button
                        onClick={() => {
                          setRedirect(`/gerencia/logins`)
                        }}
                        type="button"
                        variant="contained"
                        color="default"
                        style={{ marginRight: 30 }}
                      >
                        Cancelar
                      </Button>
                      <Button
                        type="button"
                        variant="contained"
                        color="primary"
                        onClick={save}
                      >
                        Salvar
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </Paper>
            </Grid>
          </Grid>
          <AlertDialog message={message}
            onClose={() => setMessage(false)}
            title={alertTitle}
            buttonSuccessText={'OK'}
          />
        </Container>
      </main>
    </div>
  );
}